module.exports = __webpack_public_path__ + "static/appletv-243a5ad6577d6990ad538bcbf59ae007.png";